import { render, staticRenderFns } from "./VlSortIcon.vue?vue&type=template&id=36b35039&scoped=true&"
import script from "./VlSortIcon.vue?vue&type=script&lang=js&"
export * from "./VlSortIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b35039",
  null
  
)

export default component.exports